module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step0_Titlecard.671609aa.jpg";